import { render, staticRenderFns } from "./WidgetArchiveProposal-Layouts.vue?vue&type=template&id=4fbe09b0&scoped=true&"
import script from "./WidgetArchiveProposal-Layouts.vue?vue&type=script&lang=js&"
export * from "./WidgetArchiveProposal-Layouts.vue?vue&type=script&lang=js&"
import style0 from "./WidgetArchiveProposal-Layouts.vue?vue&type=style&index=0&id=4fbe09b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbe09b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VChip,VIcon,VSimpleTable})
